import { render } from "./EditPaymethod.vue?vue&type=template&id=0068abb6"
import script from "./EditPaymethod.vue?vue&type=script&lang=js"
export * from "./EditPaymethod.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0068abb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0068abb6', script)) {
    api.reload('0068abb6', script)
  }
  
  module.hot.accept("./EditPaymethod.vue?vue&type=template&id=0068abb6", () => {
    api.rerender('0068abb6', render)
  })

}

script.__file = "src/views/settings/modules/EditPaymethod.vue"

export default script